export default __webpack_public_path__ + "static/media/ltc.d2b8d1dc.svg";